import ajaxRequest from './ajax'
import qs from "qs"

// 获取应用市场
export const get_app_market = params => {
  return ajaxRequest.post('/App/get_app_market',params);
}
// 获取 安装
export const get_app_install = params => {
  return ajaxRequest.post('/App/get_app_install' , params);
}
// 获取 场景参数
export const get_app_scene = params => {
  return ajaxRequest.post('/App/get_app_scene' , params);
}
// 获取 app 绑定场景的初始值
export const get_app_market_scene = params => {
  return ajaxRequest.post('/App/get_app_market_scene' , params);
}
// 获取 event与场景参数的配置
export const get_app_config = params => {
  return ajaxRequest.post('/App/get_app_config' , params);
}
// 获取 有效的应用市场
export const get_valid_market = params => {
  return ajaxRequest.get('/App/get_valid_market?' + qs.stringify(params ));
}



// WEBPACK FOOTER //
// ./src/api/app.js